export default __webpack_public_path__ + "static/media/pricingbg.cbd6193e.mp4";